/* eslint-disable prettier/prettier */
export const card = [
  'flex w-full flex-col border border-[#33323626] rounded-[1.5rem] overflow-hidden',
  'md:h-[27.5rem] md:flex-row md:justify-between'
].join(' ');

export const content = [
  'px-5 pt-5 pb-[4.813rem]',
  'md:flex md:w-full md:flex-col md:justify-center md:px-0 md:pt-0 md:pb-0 md:pl-[5rem] md:bg-[linear-gradient(180deg,_#F6F6F8_49.52%,_#FBFBFB_100%)]'
].join(' ');

export const eyebrow = [
  'w-fit rounded-[2rem] bg-[#3D43FC] px-2.5 py-0.5 text-[#FBF5FF] font-bold text-[0.875rem] leading-[1.375rem] tracking-[-0.019rem]'
].join(' ');

export const title = [
  'font-bold text-[#1F2937]',
  'text-[1.5rem] leading-[130%] tracking-[-0.019rem] mt-5',
  'md:mt-2.5 md:text-[2.25rem] md:leading-[2.754rem] md:tracking-[-0.019rem]'
].join(' ');

export const description = [
  'text-[#6B7280] whitespace-pre-line',
  'mt-2 text-[0.938rem] leading-[150%]',
  'md:mt-4 md:text-[1.125rem] md:leading-[1.566rem] md:text-medium'
].join(' ');

export const imageWrap = [
  'relative w-full flex flex-shrink-0 bg-red-500',
  'h-[16.1rem]',
  'md:h-[27.5rem] md:w-[32.875rem]' 
].join(' ');

export const image = 'object-cover';
